import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const TennisIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="tennis-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 19"
    className={twMerge('h-6 w-6 stroke-current', className)}
    {...props}
  >
    <path
      strokeMiterlimit="10"
      d="m7.5 9.3-2 4.2 4.3-2m1-9.9 6.7 6.7M8 4.5l6.3 6.2m-5.8-.4 8.2-8.2m-6.7.1c1-1 2.3-1.6 3.6-1.6h.1C15 .6 16.1 1 17 2c1 .9 1.4 2.1 1.4 3.4 0 1.3-.6 2.6-1.6 3.6a10 10 0 0 1-4.5 2.4c-1.8.5-3.3.2-4.1-.6-1.8-1.7-.6-6.2 1.7-8.5l.1-.1Zm-4.8 11 .6.6c.2.2.2.6 0 .8l-3.7 3.7c-.2.2-.5.2-.8 0l-.6-.6a.6.6 0 0 1 0-.8l3.7-3.7c.2-.2.6-.2.8 0Z"
    />
  </svg>
)
